// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2tVwX{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;gap:8px}._2CPWr{display:-ms-flexbox;display:flex;-ms-flex:1 1 auto;flex:1 1 auto;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;background:#fff;border:1px solid #d9dfe6;border-radius:36px;cursor:pointer;height:48px}.jcyzd{background:#3f9fff;border:1px solid #3f9fff;color:#fff}", ""]);
// Exports
exports.locals = {
	"glucoseLevelUnitTypes": "_2tVwX",
	"glucoseLevelUnitTypes__unit": "_2CPWr",
	"glucoseLevelUnitTypes__unit--selected": "jcyzd"
};
module.exports = exports;
